import React from 'react';

export const MinusIcon = () => <>&ndash;</>;
